<template>
  <b-col sm="12" lg="12">
    <div class="animated fadeIn">
      <b-card ref="cardRef" class="backClass">
        <LoadingCard v-if="loadingData"></LoadingCard>
        <div v-else>
          <h4 style="display:inline-block">Locations Assigned</h4>
          <b-form-input
            style="display:inline-block; width:250px;float:right"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <b-row>
            <b-col
              v-for="location in filterItems(locations)"
              lg="2"
              sm="6"
              :key="location.id"
              style="padding: 5px;"
            >
              <a
                class="locationLabels"
                :href="
                  '#/base/CityDashboard/?loc=' +
                    location.id +
                    '&city=' +
                    location.locaton +
                    '&lat=' +
                    location.lat +
                    '&lng=' +
                    location.lng
                "
                v-b-tooltip.hover
                :title="location.id + ' - ' + location.contact"
                >{{ location.locaton }}</a
              >
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import LoadingCard from "../shared/LoadingCard.vue";

export default {
  name: "ProfileLocations",
  components: { LoadingCard },
  props: ["locationData"],
  data() {
    return {
      searchQuery: "",
      loadingData: false,
      locations: []
    };
  },
  methods: {
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.locaton.match(regex);
      });
    }
  },
  mounted() {
    this.locations = this.locationData;
    this.loadingData = false;
  }
};
</script>

<style scoped>
.locationLabels {
  padding: 9px;
}
</style>
